module.exports = __webpack_public_path__ + "static/media/Avatar_default.a1a56d52.png";